import { render, staticRenderFns } from "./VariationPrice.vue?vue&type=template&id=4efaf654"
import script from "./VariationPrice.vue?vue&type=script&lang=js"
export * from "./VariationPrice.vue?vue&type=script&lang=js"
import style0 from "./VariationPrice.vue?vue&type=style&index=0&id=4efaf654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports